import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import type { OnboardingPersonalisationResponse } from './types.tsx';

const LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE = 'response';

const localStorage = createLocalStorageProvider('jira-onboarding-personalisation');

export const getLocalStorageOnboardingPersonalisationResponse = ():
	| OnboardingPersonalisationResponse
	| undefined => {
	try {
		return localStorage.get(LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageGetOnboardingPersonalisation',
				packageName: 'jiraOnboardingCore',
				teamName: 'jlove-makkuro',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		return undefined;
	}
};

export const setLocalStorageOnboardingPersonalisationResponse = (
	response: OnboardingPersonalisationResponse,
): void => {
	try {
		localStorage.set(LOCALSTORAGE_ONBOARDING_PERSONALISATION_RESPONSE, response);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'localStorageSetOnboardingPersonalisationResponse',
				packageName: 'jiraOnboardingCore',
				teamName: 'jlove-makkuro',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
	}
};
